import React from 'react';
import { Image } from 'pure-react-carousel';
import { cn } from '@express-labs/raven-tools';
import Link from '../../../Link/Link';
import s from './VisualNavFirstCard.scss';
import { FirstCard } from '../../Carousel';

export type LinkProps = {
  linkText?: string;
  linkUrl?: string;
  linkTextColor?: string;
};

export type VisualNavFirstCardProps = {
  cardData: FirstCard;
};

function getButtons(links?: LinkProps[] | null) {
  if (!!links && links.length > 0) {
    const isTooLong = links.some(
      (link) => link.linkText && link.linkText.length > 9
    );
    const shouldItemWrap = links.length === 1 || links.length > 2 || isTooLong;
    return links.map((link, i) => {
      const { linkUrl, linkText } = link;

      if (linkUrl && linkText) {
        return (
          <Link
            key={`nav-${i}`}
            href={linkUrl}
            className={cn(s.cardLink, !!shouldItemWrap && s.cardLinkWrap)}
            data-testid="visual-nav-button"
          >
            {linkText}
          </Link>
        );
      }
      return null;
    });
  }
  return null;
}

function getUrl(links?: LinkProps[] | null) {
  if (!!links && links.length > 0) {
    return links[0].linkUrl;
  }
  return undefined;
}

export default function VisualNavFirstCard(props: VisualNavFirstCardProps) {
  const { cardData } = props;
  const shouldDisplayHeading = !!cardData.title && !!cardData.description;

  if (shouldDisplayHeading) {
    return (
      <div className={cn(s.container, !cardData.image && s.containerNoImage)}>
        {!!cardData.image && (
          <Image
            hasMasterSpinner={false}
            className={s.image}
            alt={cardData.imageAlt || ''}
            src={cardData.image}
          />
        )}
        <div className={s.overlay}>
          <div className={s.cardTitleArea}>
            <h1 className={s.cardTitle}>{cardData.title}</h1>
          </div>
          <div className={s.cardBody}>{cardData.description}</div>
          <div className={s.cardLinks} data-testid="visualNav-links">
            {getButtons(cardData.links)}
          </div>
        </div>
      </div>
    );
  }
  return (
    <Link href={getUrl(cardData.links)} className={s.imageLink}>
      <Image
        hasMasterSpinner={false}
        className={s.image}
        alt={cardData.imageAlt || ''}
        src={cardData.image || ''}
      />
    </Link>
  );
}
